export default {
  listFolderReceiveMail: [],
  listRuleReceiveMail: [],
}